import { render, staticRenderFns } from "./gallery-form.vue?vue&type=template&id=7f10232e&"
import script from "./gallery-form.vue?vue&type=script&lang=ts&"
export * from "./gallery-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports